import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
    // null = checking, false = logged out, object = logged in
    const [user, setUser] = useState(null);

    useEffect(() => {
        // CRITICAL: if returning from the OAuth callback, skip the /me check —
        // AuthCallback exchanges the session_id and establishes the session first.
        if (window.location.hash?.includes("session_id=")) {
            setUser(false);
            return;
        }
        api.get("/auth/me")
            .then(({ data }) => setUser(data.user || false))
            .catch(() => setUser(false));
    }, []);

    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const login = () => {
        const redirectUrl = window.location.origin + "/perfil";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    };

    const logout = async () => {
        try {
            await api.post("/auth/logout");
        } catch {
            // noop
        }
        setUser(false);
    };

    return <AuthContext.Provider value={{ user, setUser, login, logout }}>{children}</AuthContext.Provider>;
};

export default AuthProvider;
